import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'countryName',
    standalone: false
})
export class CountryNamePipe implements PipeTransform {
    private translateService = inject(TranslateService);

    /**
     * Takes a language code and returns the country name.
     */
    transform(value?: string) {
        if (!value) {
            return '';
        }

        const key = `COUNTRY.${value.toUpperCase()}`;
        const countryName = this.translateService.instant(key);

        return key === countryName ? value : countryName;
    }
}
